/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminSendSmsRequest
 */
export interface AdminSendSmsRequest {
    /**
     * 
     */
    to: string;
    /**
     * 
     */
    body: string;
    /**
     * 
     */
    mediaUrl?: string | null;
    /**
     * 
     */
    channel?: AdminSendSmsRequestChannelEnum;
}


/**
 * @export
 */
export const AdminSendSmsRequestChannelEnum = {
    Sms: 'sms',
    Whatsapp: 'whatsapp',
} as const;
export type AdminSendSmsRequestChannelEnum = typeof AdminSendSmsRequestChannelEnum[keyof typeof AdminSendSmsRequestChannelEnum];


/**
 * Check if a given object implements the AdminSendSmsRequest interface.
 */
export function instanceOfAdminSendSmsRequest(value: object): value is AdminSendSmsRequest {
    if (!('to' in value) || value['to'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function AdminSendSmsRequestFromJSON(json: any): AdminSendSmsRequest {
    return AdminSendSmsRequestFromJSONTyped(json, false);
}

export function AdminSendSmsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminSendSmsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'to': json['to'],
        'body': json['body'],
        'mediaUrl': json['media_url'] === undefined ? undefined : json['media_url'] === null ? null : json['media_url'],
        'channel': json['channel'] == null ? undefined : json['channel'],
    };
}

export function AdminSendSmsRequestToJSON(json: any): AdminSendSmsRequest {
    return AdminSendSmsRequestToJSONTyped(json, false);
}

export function AdminSendSmsRequestToJSONTyped(value?: AdminSendSmsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'to': value['to'],
        'body': value['body'],
        'media_url': value['mediaUrl'],
        'channel': value['channel'],
    };
}

